/* Aitomatto iPhone AR: photo -> metric GLB -> Apple Quick Look via model-viewer */
(function(){
'use strict';
const ua=navigator.userAgent||'';
const isIOS=/iPhone|iPad|iPod/i.test(ua)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1);
if(!isIOS)return;
const pad=n=>(n+3)&~3;
function makeGlb(image,width,length){
  const x=width/2,z=length/2;
  const parts=[
    new Uint8Array(new Float32Array([-x,0,-z,x,0,-z,x,0,z,-x,0,z]).buffer),
    new Uint8Array(new Float32Array([0,1,0,0,1,0,0,1,0,0,1,0]).buffer),
    new Uint8Array(new Float32Array([0,1,1,1,1,0,0,0]).buffer),
    new Uint8Array(new Uint16Array([0,2,1,0,3,2]).buffer),
    image
  ];
  const views=[];let len=0;
  for(const part of parts){views.push({buffer:0,byteOffset:len,byteLength:part.byteLength});len+=pad(part.byteLength);}
  const bin=new Uint8Array(len);parts.forEach((part,i)=>bin.set(part,views[i].byteOffset));
  const doc={
    asset:{version:'2.0',generator:'Aitomatto rug AR'},
    scene:0,scenes:[{nodes:[0]}],nodes:[{mesh:0}],
    meshes:[{primitives:[{attributes:{POSITION:0,NORMAL:1,TEXCOORD_0:2},indices:3,material:0,mode:4}]}],
    accessors:[
      {bufferView:0,componentType:5126,count:4,type:'VEC3',min:[-x,0,-z],max:[x,0,z]},
      {bufferView:1,componentType:5126,count:4,type:'VEC3'},
      {bufferView:2,componentType:5126,count:4,type:'VEC2'},
      {bufferView:3,componentType:5123,count:6,type:'SCALAR'}
    ],
    bufferViews:views,buffers:[{byteLength:len}],
    images:[{bufferView:4,mimeType:'image/png'}],
    samplers:[{magFilter:9729,minFilter:9729,wrapS:33071,wrapT:33071}],
    textures:[{sampler:0,source:0}],
    materials:[{doubleSided:true,alphaMode:'BLEND',pbrMetallicRoughness:{baseColorTexture:{index:0},metallicFactor:0,roughnessFactor:1}}]
  };
  const encoded=new TextEncoder().encode(JSON.stringify(doc)),jsonSize=pad(encoded.byteLength);
  const size=12+8+jsonSize+8+len,buffer=new ArrayBuffer(size),view=new DataView(buffer),bytes=new Uint8Array(buffer);
  view.setUint32(0,0x46546c67,true);view.setUint32(4,2,true);view.setUint32(8,size,true);
  view.setUint32(12,jsonSize,true);view.setUint32(16,0x4e4f534a,true);
  bytes.set(encoded,20);bytes.fill(32,20+encoded.length,20+jsonSize);
  view.setUint32(20+jsonSize,len,true);view.setUint32(24+jsonSize,0x004e4942,true);
  bytes.set(bin,28+jsonSize);
  return new Blob([buffer],{type:'model/gltf-binary'});
}
/* Remove only near-white background connected to the image borders. */
function aitClearBackdrop(canvas){
  const ctx=canvas.getContext('2d',{willReadFrequently:true});
  if(!ctx)return canvas;
  const w=canvas.width,h=canvas.height;
  if(!w||!h||w*h>1800000)return canvas;
  let image;
  try{image=ctx.getImageData(0,0,w,h);}catch(e){return canvas;}
  const data=image.data,seen=new Uint8Array(w*h),queue=new Int32Array(w*h);
  let head=0,tail=0;
  function isPaper(pos){
    const p=pos*4,r=data[p],g=data[p+1],b=data[p+2];
    return data[p+3]<25||(r>218&&g>218&&b>218&&Math.max(r,g,b)-Math.min(r,g,b)<31);
  }
  function add(pos){if(!seen[pos]&&isPaper(pos)){seen[pos]=1;queue[tail++]=pos;}}
  for(let x=0;x<w;x++){add(x);add((h-1)*w+x);}
  for(let y=0;y<h;y++){add(y*w);add(y*w+w-1);}
  // Don't remove white parts of rugs when there is no clear light border.
  if(tail<(w+h)/8)return canvas;
  while(head<tail){
    const p=queue[head++],x=p%w,y=(p/w)|0;
    if(x>0)add(p-1);if(x<w-1)add(p+1);
    if(y>0)add(p-w);if(y<h-1)add(p+w);
  }
  for(let i=0;i<tail;i++)data[queue[i]*4+3]=0;
  ctx.putImageData(image,0,0);
  return canvas;
}

async function photoBytes(url){
  const response=await fetch(url,{mode:'cors',credentials:'omit'});
  if(!response.ok)throw Error('image download failed');
  const imageUrl=URL.createObjectURL(await response.blob());
  try{
    const image=new Image();image.src=imageUrl;await image.decode();
    const ratio=Math.min(1,1024/Math.max(image.naturalWidth,image.naturalHeight));
    const canvas=document.createElement('canvas');
    canvas.width=Math.max(1,Math.round(image.naturalWidth*ratio));
    canvas.height=Math.max(1,Math.round(image.naturalHeight*ratio));
    const ctx=canvas.getContext('2d',{alpha:true});
    if(!ctx)throw Error('canvas unavailable');
    ctx.drawImage(image,0,0,canvas.width,canvas.height);
    aitClearBackdrop(canvas);
    const png=await new Promise((resolve,reject)=>canvas.toBlob(b=>b?resolve(b):reject(Error('png conversion failed')),'image/png'));
    return new Uint8Array(await png.arrayBuffer());
  }finally{URL.revokeObjectURL(imageUrl);}
}
let libraryPromise;
function library(){
  if(!libraryPromise){
    libraryPromise=new Promise((resolve,reject)=>{
      if(customElements.get('model-viewer')){resolve();return;}
      const script=document.createElement('script');
      script.type='module';script.src='https://ajax.googleapis.com/ajax/libs/model-viewer/4.3.1/model-viewer.min.js';
      script.onerror=()=>reject(Error('model-viewer unavailable'));
      document.head.appendChild(script);
      const timeout=setTimeout(()=>reject(Error('model-viewer timeout')),25000);
      customElements.whenDefined('model-viewer').then(()=>{clearTimeout(timeout);resolve();});
    });
  }
  return libraryPromise;
}
function start(root){
  if(root.dataset.iosArReady)return;
  // The product-gallery script moves the button out of the AR section.
  // Find it in either location so iPhone can attach its click handler.
  const button=root.querySelector('.ait-real-ar-launch') || document.querySelector('#MainContent media-gallery .ait-real-ar-launch--on-image');
  const help=root.querySelector('.ait-real-ar-help');
  const label=button?.querySelector('.ait-real-ar-launch-label');
  const width=Number(root.dataset.width),length=Number(root.dataset.length);
  if(!button||!help||!(width>0)||!(length>0))return;
  root.dataset.iosArReady='loading';
  let ready=false,viewer=null,failed=false;
  const normalLabel=label?.textContent||'Katso matto huoneessasi';
  if(label)label.textContent='Valmistellaan AR:ää…';
  button.addEventListener('click',event=>{
    event.preventDefault();event.stopPropagation();event.stopImmediatePropagation();
    if(failed){help.textContent='iPhonen AR ei käynnisty. Avaa tämä tuotesivu Safarissa.';return;}
    if(!ready||!viewer){help.textContent='AR-mallia valmistellaan. Odota hetki ja napauta uudelleen.';return;}
    help.textContent='Avataan Applen AR-näkymää…';
    try{const result=viewer.activateAR();if(result&&result.catch)result.catch(()=>{help.textContent='AR:n avaaminen ei onnistunut. Kokeile Safarissa.';});}
    catch(error){help.textContent='AR:n avaaminen ei onnistunut. Kokeile Safarissa.';}
  },true);
  (async()=>{
    const results=await Promise.all([library(),photoBytes(root.dataset.image)]);
    const glb=makeGlb(results[1],width,length);
    const modelUrl=URL.createObjectURL(glb);
    viewer=document.createElement('model-viewer');
    viewer.setAttribute('ar','');viewer.setAttribute('ar-modes','quick-look');
    viewer.setAttribute('ar-placement','floor');viewer.setAttribute('ar-scale','auto');
    viewer.setAttribute('ar-usdz-max-texture-size','1024');
    viewer.setAttribute('loading','eager');viewer.setAttribute('camera-controls','');
    viewer.setAttribute('alt','Matto '+width+' x '+length+' metriä');
    viewer.style.cssText='position:fixed;left:-250px;top:-250px;width:120px;height:120px;opacity:0;pointer-events:none';
    document.body.appendChild(viewer);
    await new Promise((resolve,reject)=>{
      const timer=setTimeout(()=>reject(Error('3D model timeout')),30000);
      viewer.addEventListener('load',()=>{clearTimeout(timer);resolve();},{once:true});
      viewer.addEventListener('error',()=>{clearTimeout(timer);reject(Error('3D model error'));},{once:true});
      viewer.src=modelUrl;
    });
    await viewer.updateComplete;
    // AR mode selection can finish shortly after the model's load event.
    for(let attempt=0;attempt<24 && !viewer.canActivateAR;attempt++){
      await new Promise(resolve=>setTimeout(resolve,200));
    }
    if(!viewer.canActivateAR)throw Error('Quick Look unavailable');
    ready=true;root.dataset.iosArReady='true';
    if(label)label.textContent=normalLabel;
    if(help.textContent.includes('valmistellaan'))help.textContent='AR on valmis. Napauta painiketta uudelleen.';
  })().catch(error=>{
    failed=true;root.dataset.iosArReady='error';
    if(label)label.textContent=normalLabel;
    const reason=(error && error.message)||'unknown';
    console.warn('[Aitomatto iPhone AR] '+reason,error);
    if(/model-viewer|3D model timeout|library/i.test(reason)){
      help.textContent='3D-katselimen lataus ei onnistunut. Tarkista verkkoyhteys ja avaa sivu Safarissa.';
    }else if(/image|png/i.test(reason)){
      help.textContent='Maton AR-kuvaa ei voitu valmistella. Päivitä sivu ja yritä uudelleen.';
    }else{
      help.textContent='iPhone-AR ei käynnistynyt. Avaa sivu Safarissa ja yritä uudelleen.';
    }
  });
}
function init(){document.querySelectorAll('.ait-real-ar[data-image][data-width][data-length]').forEach(start);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
document.addEventListener('shopify:section:load',init);
})();